import styled from 'styled-components';

export const FlexTitle = styled.div`
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  gap: 10px;
  padding: 0 0 20px;
`;
